/* eslint-disable import/no-anonymous-default-export */
export default (branchAdvice = [], action) => {
  switch (action.type) {
    case "GET_BRANCH_ADVICE":
      return action.payload;
    case "CLEAR_BRANCH_ADVICE":
      return branchAdvice.filter((data) => data._id !== action.payload);

    default:
      return branchAdvice;
  }
};
